import { useEnvironment } from "@contember/binding";
import { useMemo } from "react";
import { blockAnalyzer } from "./blockAnalyzer.js";
const useBlockProps = (children) => {
  const environment = useEnvironment();
  return useMemo(() => {
    if (children === void 0) {
      return [];
    }
    return blockAnalyzer.processChildren(children, environment);
  }, [children, environment]);
};
export {
  useBlockProps
};
//# sourceMappingURL=useBlockProps.js.map
